import { useEventTracking } from '../../../../../helpers/gtmHelper'
import { AccuracyDetailItem, CAF_ANALYSIS_TYPE_MAP } from '../../../../../model/caf.interface'
import { useCafAnalysisComponentDetailListV5 } from '../../../../../modules/apis/webview/caf'
import useIsWebview from '../../../../../modules/hooks/common/useIsWebview'
import { mapAccuracyEnum, mapAccuracyEnumEN } from '../../../../../modules/hooks/webview/caf/common/useMapAccuracyEnum'
import useWebviewNavigation from '../../../../../modules/hooks/webview/common/useWebviewNavigation'
import { n_caf } from '../../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import urls from '../../../../../modules/urls'
import { LESSON_ACTIVITIES_MAP, useLessonsStack } from '../../../../../pages/[lang]/webview/lessons'
import LoadingSpinner from '../../../../common/LoadingSpinner'
import ArrowLinkBoxBG from '../../common/ArrowLinkBoxBG'

const AccuracyErrorListSection = ({ componentId }) => {
  const { t, locale } = useTranslation()
  const { useLessonsFlow } = useLessonsStack()
  const isWebview = useIsWebview()
  const { push } = useLessonsFlow()

  const { data, isLoading } = useCafAnalysisComponentDetailListV5(componentId)
  const { sendPageViewEvent } = useEventTracking()

  const { navigate } = useWebviewNavigation()
  const handleClickErrorItem = (metricId: number, errorTag: number) => {
    if (isWebview) {
      sendPageViewEvent({ page_name: 'ai_accuracy_error_type', object_id: errorTag })
      push(LESSON_ACTIVITIES_MAP.AIAccuracyMetricDetailActivity, {
        metricId,
        error_tag: errorTag,
      })
    } else {
      navigate({ url: urls.webview.caf.analysis.detail(CAF_ANALYSIS_TYPE_MAP[2], metricId, errorTag) })
    }
  }
  if (isLoading || !data)
    return (
      <div className="flex h-[100px] w-screen items-center justify-center">
        <LoadingSpinner show primary />
      </div>
    )
  return (
    <section className="py-[24px]">
      <h2 className="text-sTitle mb-[12px] font-bold text-black">{t(n_caf.accuracy.grammarerror_type)}</h2>
      {data.metrics[0]?.details?.map((metricItem: AccuracyDetailItem) => (
        <ArrowLinkBoxBG
          key={metricItem.error_type + '_metric'}
          title={mapAccuracyEnum(metricItem.error_tag, t)}
          subText={locale === 'ko' && mapAccuracyEnumEN(metricItem.error_tag, t)}
          rightText={metricItem.count}
          active={!!metricItem.count}
          onClick={
            metricItem.count > 0 ? () => handleClickErrorItem(data.metrics[0].metric_id, metricItem.error_tag) : null
          }
        />
      ))}
    </section>
  )
}

export default AccuracyErrorListSection
